import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, ProtectedRoute } from "@/context/AuthContext";
import AdminLayout from "@/components/admin/AdminLayout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Clients from "@/pages/Clients";
import ClientDetail from "@/pages/ClientDetail";
import Cards from "@/pages/Cards";
import Editor from "@/pages/Editor";
import QrPage from "@/pages/QrPage";
import CardAnalytics from "@/pages/CardAnalytics";
import Analytics from "@/pages/Analytics";
import Settings from "@/pages/Settings";
import PublicCard from "@/pages/PublicCard";
import Privacy from "@/pages/Privacy";
import ClientPortal from "@/pages/ClientPortal";
import QrLinks from "@/pages/QrLinks";
import QrLinkDetail from "@/pages/QrLinkDetail";
import QrRedirect from "@/pages/QrRedirect";
import CookiePolicy from "@/pages/CookiePolicy";
import HomeGate from "@/pages/HomeGate";
import Unsubscribe from "@/pages/Unsubscribe";
import PortalQr from "@/pages/PortalQr";
import ChangePassword from "@/pages/ChangePassword";
import { ForgotPassword, ResetPassword } from "@/pages/ResetPassword";
import { CookieBanner } from "@/components/legal/CookieBanner";

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/" element={<HomeGate />} />
          <Route path="/login" element={<Login />} />
          <Route path="/c/:slug" element={<PublicCard />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/cookie" element={<CookiePolicy />} />
          <Route path="/password-dimenticata" element={<ForgotPassword />} />
          <Route path="/reset-password/:token" element={<ResetPassword />} />
          <Route path="/disiscrizione/:token" element={<Unsubscribe />} />
          <Route path="/q/:code" element={<QrRedirect />} />
          <Route path="/portale" element={<ProtectedRoute role="client"><ClientPortal /></ProtectedRoute>} />
          <Route path="/portale/password" element={<ProtectedRoute role="client"><ChangePassword /></ProtectedRoute>} />
          <Route path="/portale/qr/:id" element={<ProtectedRoute role="client"><PortalQr /></ProtectedRoute>} />
          <Route path="/portale/card/:id" element={<ProtectedRoute role="client"><Editor /></ProtectedRoute>} />
          <Route path="/admin/card/:id/editor" element={<ProtectedRoute><Editor /></ProtectedRoute>} />
          <Route path="/admin" element={<ProtectedRoute><AdminLayout /></ProtectedRoute>}>
            <Route index element={<Dashboard />} />
            <Route path="clienti" element={<Clients />} />
            <Route path="clienti/:id" element={<ClientDetail />} />
            <Route path="card" element={<Cards />} />
            <Route path="card/:id/qr" element={<QrPage />} />
            <Route path="card/:id/statistiche" element={<CardAnalytics />} />
            <Route path="statistiche" element={<Analytics />} />
            <Route path="qr" element={<QrLinks />} />
            <Route path="qr/:id" element={<QrLinkDetail />} />
            <Route path="impostazioni" element={<Settings />} />
          </Route>
          <Route path="*" element={<Navigate to="/admin" replace />} />
        </Routes>
        <CookieBanner />
        <Toaster position="bottom-right" />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
